// Module
var code = `<breadcrumbs></breadcrumbs>
<section class="box">
  <sub-header header="\$ctrl.title"></sub-header>

<div class="cr-container">
  <div class="cr-top">
    <div class="cr-top-editor">
      <div class="filters">
        <div class="labelled-field labelled-field--long">
          <label>Query name</label>
          <input type="text" ng-model="\$ctrl.reportName"/>
        </div>
        <button type="button" class="btn btn-primary" ng-click="\$ctrl.saveQuery()" ng-disabled="\$ctrl.isQueryEmpty() || !\$ctrl.reportName">Save</button>
        <button type="button" class="btn btn-info" ng-click="\$ctrl.downloadXLS()" ng-disabled="\$ctrl.isQueryEmpty()">XLS</button>
        <button type="button" class="btn btn-success" ng-click="\$ctrl.runQuery()" ng-disabled="\$ctrl.isQueryEmpty()">Run query</button>
      </div>
      <sql-editor mime="text/x-pgsql" on-query-update="\$ctrl.onQueryUpdate" query="\$ctrl.populateQuery" hints="\$ctrl.hints" ng-keydown="\$event.keyCode === 13 && \$event.ctrlKey && \$ctrl.runQuery()"></sql-editor>
    </div>

    <div class="cr-top-sidenav">
      <div class="tab-menu">
        <ul class="nav-tabs">
          <li class="active">
            <a data-target="#tab-history" data-toggle="tab">
              <span>History</span>
            </a>
          </li>
          <li>
            <a data-target="#tab-saved" data-toggle="tab">
              <span>Saved</span>
            </a>
          </li>
        </ul>
      </div>

      <div class="tab-content">
        <div class="tab-pane active" id="tab-history">
          <div>
            <table ng-table="\$ctrl.historyTable" class="table">
              <tr>
                <th>#</th>
                <th>Query name</th>
                <th>Date</th>
                <th>SQL</th>
              </tr>
              <tr ng-repeat="item in \$data" ng-click="\$ctrl.editQuery(item)">
                <td>{{ \$index+1 + (\$ctrl.historyTable.page() - 1) * \$ctrl.historyTable.count() }}</td>
                <td>{{ item.name || '-' }}</td>
                <td>{{ item.date }}</td>
                <td>{{ item.sql }}</td>
              </tr>
            </table>
          </div>
        </div>
        <div class="tab-pane" id="tab-saved">
          <div>
            <table ng-table="\$ctrl.savedTable" class="table">
              <tr>
                <th>#</th>
                <th>Query name</th>
                <th>Date</th>
                <th>SQL</th>
                <th></th>
              </tr>
              <tr ng-repeat="item in \$data" ng-click="\$ctrl.editQuery(item)">
                <td>{{ \$index+1 + (\$ctrl.savedTable.page() - 1) * \$ctrl.savedTable.count() }}</td>
                <td>{{ item.name }}</td>
                <td>{{ item.date }}</td>
                <td>{{ item.sql }}</td>
                <td><button class="btn btn-danger" ng-click="\$ctrl.deleteSaved(item)" type="button">Delete</button></td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>

  <report-view report-content="\$ctrl.reportContent"></report-view>
</div>
</section>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/report/custom-query/custom-query.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;